// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-width{width:100%}.root__charging-option .tooltip .charging-tootlip__button{transform:scale(.7);position:relative;top:-4px}", ""]);
// Exports
module.exports = exports;
